import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  type IconDefinition,
} from '@fortawesome/sharp-solid-svg-icons';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Spinner from '@/components/common/loading/spinner';
import Typography from '@/components/typography';
import { GLOBAL_TOOLTIP } from '@/constants/constants';

type Props = {
  label: string;
  icon?: IconDefinition;
  iconClassName?: string;
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  tooltip?: string;
};

export const ExportMenuButton: FC<Props> = ({
  label,
  icon = faChevronRight,
  iconClassName = '',
  disabled = false,
  isLoading = false,
  onClick,
  tooltip = undefined,
}) => {
  return (
    <div
      data-tooltip-content={tooltip}
      data-tooltip-delay-show={300}
      data-tooltip-id={GLOBAL_TOOLTIP}
    >
      <button
        className={twMerge(
          'flex w-full items-center justify-between border-b border-gray-20 bg-gray-10 py-3 pl-4 pr-2 hover:bg-gray-20',
          disabled && 'opacity-30'
        )}
        disabled={disabled || isLoading}
        type="button"
        onClick={onClick}
      >
        <Typography variant="body2">{label}</Typography>
        {isLoading ? (
          <Spinner className={twMerge('h-8 w-8 p-1.5', iconClassName)} />
        ) : (
          <FontAwesomeIcon
            className={twMerge('h-5 w-5 p-1.5', iconClassName)}
            icon={icon}
          />
        )}
      </button>
    </div>
  );
};
